import { DATA } from './data';

import audio1 from '../music/chill-mood-178691.mp3';
import audio2 from '../music/drift-life-phonk-186634.mp3';
import audio3 from '../music/the-aesthetics-192274.mp3';
import audio4 from '../music/world-of-technologies-157982.mp3';

const audioClips = [audio1, audio2, audio3, audio4];

let currentAudioIndex = Math.floor(Math.random() * audioClips.length);
let audioElement = new Audio();
let isInitialized = false; // Track if audio playback has started

export function playNextAudio() {
  currentAudioIndex++;
  if (currentAudioIndex >= audioClips.length) {
    currentAudioIndex = 0;
  }
  audioElement.src = audioClips[currentAudioIndex];
  audioElement.play();
}

export function tryStartAudio() {
  if (!isInitialized) {
    isInitialized = true;
    audioElement.addEventListener('ended', playNextAudio);
    playNextAudio();
  }
}

export function setAdMute(isAdPlaying: boolean) {
  if (isAdPlaying) {
    audioElement.muted = true;
  } else {
    audioElement.muted = DATA.isMuted;
  }
}

export function setAudioMute() {
  audioElement.muted = DATA.isMuted;
}
